var metadata = require('./_metadata');
var anObject = require('./_an-object');
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/es7.reflect.define-metadata.js
 ** module id = 613
 ** module chunks = 0
 **/